<template lang="html">
    <div :class="status ? 'correct' : 'error' " class="notContainer">
            <div class="circleToast" :class="active1"><img :src="this.logo" class="logoToast"></div>
            <div class="messageToast" :class="active2"><div class="innerText"><div class="text" v-if="messages.length > 0">{{messages[0].mess}}</div></div></div>
    </div>
</template>
<script>

export default {
    name:"notificationToast",
    emits:['playSound'],
    props:{
        newMessage:{
            default:{mess:"",time:"", type:"toast"},
            type: Object
        },
        waitTime:{
            default:8000,
            type: Number
        }
    },
    watch:{
        newMessage: {
            handler(){
                if(!this.runned){
                    this.messages.push({mess:this.newMessage.mess, type:this.newMessage.type});
                    this.runned = true;
                    this.runMessage();
                }else{
                    if(this.messages[this.messages.length - 1].mess != this.newMessage.mess){
                        this.messages.push({mess:this.newMessage.mess, type:this.newMessage.type});
                    }
                }
            },
            deep: true
        }
    },
    data(){
        return{
            runned:false,
            logo:require('@/assets/images/a19.png'),
            messages:[],
            active1:"",
            active2:"",
            status:true,
        }
    },
    methods:{

        scroll(timeScroll, scroll){
            /*
                hace el scroll vertical del toast
            */
            setTimeout(()=>{
                $(".text").animate({scrollTop:scroll}, '200');
            }, timeScroll)
        },

        scroller(max, part, wait){
            /* 
                calculo de partes del texto en el contenedor para hacer scroll vertical por tiempos
            */
            return new Promise(async (resolve) => {
                let size = Math.ceil(max/part);
                let timed = wait/size;
                let scroll = 0;
                let timeScroll = 0;
                for(let i=1; i<size; i++){
                    scroll += part;
                    timeScroll += timed;
                    this.scroll(timeScroll, scroll);
                }
            })
        },

        intervalToast(wait=2500){
            /*
                procedimiento recursivo de animacion por cada mensaje en el array de mensajes, hasya terminarlos
            */
            setTimeout(()=>{
                
                switch(this.messages[0].type){
                    case "error":
                        this.status = false;
                        this.$emit('playSound', 'error');
                        break;
                    default:
                        this.status = true;
                        this.$emit('playSound', 'toast');
                        break;
                }
                this.active1 = "active";

                setTimeout(()=>{
                    this.active2 = "active";
                    if ($('.text')[0].scrollHeight >  $('.text').innerHeight()) {
                        this.scroller($('.text')[0].scrollHeight,  $('.text').innerHeight(), wait)
                    }

                    setTimeout(()=>{
                        this.active2 = "";
                        setTimeout(()=>{
                            this.active1 = "";
                            this.messages.shift();
                            if(this.messages.length > 0){
                                this.intervalToast((Math.ceil(this.messages[0].mess.length/80) * 2500));
                            }else{
                                this.runned = false;
                            }
                        },1000)
                    }, wait+1000)

                }, 1000)
            }, 300)
        },

        runMessage(){
            /* comprueba instacia de animacion */
            this.intervalToast((Math.ceil(this.messages[0].mess.length/80) * 2500));
        }
    }
}
</script>
<style lang="css">

    .notContainer{
        position: fixed;
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
        top: 0;
        left: 0;
        width: 100vw;
        height: 80px;
        z-index: 40010;
        pointer-events: none;
    }

    .circleToast{
        width: 0;
        height: 0;
        position: relative;
        border-radius: 50%;
        z-index: 10;
        overflow: hidden;
        transition: all 0.8s ease-in-out;
    }

    .circleToast.active{
        width:60px !important;
        height:60px !important;
    }

    .correct .circleToast.active{
        border:3px solid var(--primary);
        background-color: var(--primary);
    }
    .error .circleToast.active{
        border:3px solid var(--octagenary);
        background-color: var(--octagenary);
    }

    .logoToast{
        width: 100%;
        height: 100%;
        object-fit: cover;
        position: relative;
    }

    .messageToast{
        height: 60px;
        width: 0px;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
        position: relative;
        margin-left: -30px;
        background-color: var(--primary);
        color: var(--contrast1);
        font-size: 12px;
        z-index: 9;
        border-radius: 0 30px 30px 0;
        transition: width 0.6s ease-in-out;
        overflow: hidden;
    }

    .correct .messageToast{
        background-color: var(--primary);
    }
    .error .messageToast{
        background-color: var(--octagenary);
    }


    .messageToast.active{
        width: 300px !important;
    }

    .innerText{
        position: absolute;
        padding: 0 35px 0 35px;
        width: 300px !important;
        height: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
    }

    .text{
        width: 100%;
        height: auto;
        min-height: 20px;
        max-height: 36px;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        overflow: hidden;
        text-align: left;
    }

    @keyframes expand {
        0%{
            width: 0px;
        }
        6%{
            width: 300px;
        }
        95%{
            width: 300px;
        }
        100%{
            width: 0px;
        }
    }
</style>